import React, { useState, useEffect } from 'react';
import { FormField, InlineAlert, Modal, TextAreaField } from './ui';
import api from '../../services/api';

const ContentFormDialog = ({ open, onClose, pageKey, pageData, onSuccess }) => {
  const [formData, setFormData] = useState({
    title: '',
    content: '',
    whatsapp_link: '',
    instagram_link: '',
    location: '',
    schedule_title: '',
    schedule_text: '',
  });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (open && pageData) {
      setError('');
      setFormData({
        title: pageData.title || '',
        content: pageData.content || '',
        whatsapp_link: pageData.whatsapp_link || '',
        instagram_link: pageData.instagram_link || '',
        location: pageData.location || '',
        schedule_title: pageData.schedule_title || '',
        schedule_text: pageData.schedule_text || '',
      });
    }
  }, [open, pageData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    try {
      const payload =
        pageKey === 'contact'
          ? formData
          : {
              title: formData.title,
              content: formData.content,
            };
      await api.put(`/admin/pages/${pageKey}`, payload);
      onSuccess();
      onClose();
    } catch (err) {
      console.error('Error saving content:', err);
      setError(err.response?.data?.message || 'Error al guardar el contenido');
    } finally {
      setSubmitting(false);
    }
  };

  const titles = { home: 'Página principal', history: 'Historia', contact: 'Contacto' };

  return (
    <Modal
      open={open}
      title={`Editar ${titles[pageKey] || 'página'}`}
      onClose={submitting ? undefined : onClose}
      size="lg"
      footer={
        <>
          <button type="button" className="btn-admin-secondary" onClick={onClose} disabled={submitting}>
            Cancelar
          </button>
          <button type="submit" form="content-form" className="btn-admin" disabled={submitting}>
            {submitting ? 'Guardando…' : 'Guardar cambios'}
          </button>
        </>
      }
    >
      <form id="content-form" className="space-y-4" onSubmit={handleSubmit}>
        {error && <InlineAlert tone="error">{error}</InlineAlert>}
        <FormField
          id="title"
          label={pageKey === 'contact' ? 'Título de la página' : 'Título'}
          value={formData.title}
          onChange={handleChange}
          required
        />
        <TextAreaField
          id="content"
          label={pageKey === 'contact' ? 'Texto introductorio' : 'Contenido'}
          value={formData.content}
          onChange={handleChange}
          required={pageKey !== 'contact'}
          rows={pageKey === 'contact' ? 4 : 8}
        />
        {pageKey === 'contact' && (
          <>
            <TextAreaField
              id="location"
              label="Ubicación / dirección"
              value={formData.location}
              onChange={handleChange}
              rows={2}
              placeholder="Echeverría 1582, Buenos Aires, Argentina"
            />
            <FormField
              id="schedule_title"
              label="Título de horarios"
              value={formData.schedule_title}
              onChange={handleChange}
              placeholder="Nuestros horarios"
            />
            <TextAreaField
              id="schedule_text"
              label="Horarios"
              value={formData.schedule_text}
              onChange={handleChange}
              rows={3}
              placeholder="Lunes, Miércoles y Viernes: 19:30 - 21:00 hs"
            />
            <FormField
              id="whatsapp_link"
              label="Enlace de WhatsApp"
              value={formData.whatsapp_link}
              onChange={handleChange}
              placeholder="https://wa.me/5491123456789"
            />
            <FormField
              id="instagram_link"
              label="Enlace de Instagram"
              value={formData.instagram_link}
              onChange={handleChange}
              placeholder="https://instagram.com/teamkitsune"
            />
          </>
        )}
      </form>
    </Modal>
  );
};

export default ContentFormDialog;
